"use client";

import ToolResultTable from "@/components/tools/ToolResultTable";
import { applyToolResultVisualBadges } from "@/components/tools/tool-result-helpers";
import type { ToolsContent } from "@/lib/content/tools";
import type { ToolId } from "@/lib/content/tools/config";
import { getToolResultSections } from "@/lib/tools/tool-result-sections";
import { getToolResultData } from "@/lib/tools/tool-response";

/** Client-only results for turnstile tools (avoids bundling all tool result UIs). */
export default function ToolTurnstileResults({
  toolId,
  payload,
  ui,
}: {
  toolId: ToolId;
  payload: unknown;
  ui: ToolsContent["toolsUi"];
}) {
  const data = getToolResultData(payload);
  if (!data) {
    return null;
  }

  const sections = getToolResultSections(toolId, data, ui);
  if (!sections) {
    return null;
  }

  const displaySections = applyToolResultVisualBadges(toolId, sections, ui);

  return <ToolResultTable sections={displaySections} />;
}
